<template>
  <span class="animated-number">{{ displayValue }}</span>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';

const props = defineProps({
  value: {
    type: Number,
    default: 0
  },
  duration: {
    type: Number,
    default: 1000
  },
  decimals: {
    type: Number,
    default: 0
  }
});

const displayValue = ref(0);

const animateValue = (start, end, duration) => {
  const startTime = Date.now();
  const endTime = startTime + duration;
  
  const step = () => {
    const now = Date.now();
    const remaining = Math.max((endTime - now) / duration, 0);
    const value = Math.round((end - start) * (1 - remaining) + start);
    
    displayValue.value = props.decimals > 0 
      ? (value / Math.pow(10, props.decimals)).toFixed(props.decimals)
      : value;
    
    if (remaining > 0) {
      requestAnimationFrame(step);
    }
  };
  
  step();
};

// 监听值变化
watch(() => props.value, (newVal, oldVal) => {
  animateValue(oldVal || 0, newVal, props.duration);
}, { immediate: true });

onMounted(() => {
  animateValue(0, props.value, props.duration);
});
</script>

<style scoped>
.animated-number {
  font-weight: bold;
  font-variant-numeric: tabular-nums;
}
</style> 